import { BoundDetailsHelper } from './base'

export const BoundDetails = BoundDetailsHelper.defineMultiStyleConfig({})
